export default "__VITE_ASSET__5b143220__"